export default __webpack_public_path__ + "static/media/cvod-R13.81d38ec8.svg";